import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button, Col, Collapse, Form, Row } from 'react-bootstrap';
import InputField from '../InputField';
import DatePicker from 'react-datepicker';

const ExperienceForm = ({
  collapsed,
  setCollapsed,
  experiences,
  setExperience
}) => {
  const [formData, setFormData] = useState({
    company: '',
    position: '',
    positionType: '',
    currentlyWork: false,
    from: new Date(),
    to: new Date(),
    unit: '',
    hourseWorkedWeek: '',
    state: '',
    country: ''
  });

  const options = ['Staff', 'Part-Time', 'Per Diem', 'Travel'];

  const handleChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = e => {
    e.preventDefault();
    // console.log(formData);
    setExperience([
      ...experiences,
      {
        title: formData?.position,
        company: formData?.company,
        startDate: formData?.from,
        endDate: formData?.to,
        positionType: formData?.positionType,
        unit: formData?.unit,
        hourseWorkedWeek: formData?.hourseWorkedWeek,
        state: formData?.state,
        country: formData?.country,
        currentlyWork: formData?.currentlyWork
      }
    ]);
    setFormData({
      company: '',
      position: '',
      positionType: '',
      currentlyWork: false,
      from: new Date(),
      to: new Date(),
      unit: '',
      hourseWorkedWeek: '',
      state: '',
      country: ''
    });
    setCollapsed(!collapsed);
  };

  // console.log(experiences);

  return (
    <div>
      <Flex
        alignItems="center"
        className="mb-4 text-primary cursor-pointer fs-9"
        onClick={() => {
          setCollapsed(!collapsed);
        }}
      >
        <span className="circle-dashed">
          <FontAwesomeIcon icon="plus" />
        </span>
        <span className="ms-3">New experience</span>
      </Flex>
      <Collapse in={!collapsed}>
        <div>
          {/* <ExperienceForm /> */}
          <Form onSubmit={handleSubmit}>
            <InputField
              value={formData.company}
              label="Company"
              name="company"
              handleChange={handleChange}
            />
            <InputField
              value={formData.position}
              label="Position"
              name="position"
              handleChange={handleChange}
            />
            <Form.Group as={Row} className="mb-3" controlId="positionType">
              <Col sm={{ span: 7, offset: 3 }}>
                <Form.Select
                  onChange={e =>
                    setFormData(prevState => {
                      return { ...prevState, positionType: e.target.value };
                    })
                  }
                  size="sm"
                  required
                >
                  <option value="">Select Type</option>
                  {options.map(option => (
                    <option key={option}>{option}</option>
                  ))}
                </Form.Select>
              </Col>
            </Form.Group>
            <InputField
              value={formData.state}
              label="State"
              name="state"
              handleChange={handleChange}
            />
            <InputField
              value={formData.country}
              label="Country"
              name="country"
              handleChange={handleChange}
            />
            {/* <InputField
              value={formData.description}
              label="Description"
              name="description"
              handleChange={handleChange}
              as="textarea"
              rows={3}
            /> */}
            <InputField
              value={formData.unit}
              label="Unit"
              name="unit"
              handleChange={handleChange}
            />
            <InputField
              value={formData.hourseWorkedWeek}
              label="Hours Worked/Week"
              name="hourseWorkedWeek"
              handleChange={handleChange}
            />
            <Form.Group as={Row} className="mb-3" controlId={name}>
              <Form.Label column sm={3} className="text-lg-end">
                From
              </Form.Label>
              <Col sm={9} md={7}>
                <DatePicker
                  selected={formData.from}
                  onChange={date => setFormData({ ...formData, from: date })}
                  className="form-control form-control-sm"
                  placeholderText="Select Date"
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="currentlyWork">
              <Col sm={{ span: 10, offset: 3 }}>
                <Form.Check
                  type="checkbox"
                  label="I currently work here"
                  checked={formData.currentlyWork}
                  onChange={({ target }) =>
                    setFormData({ ...formData, currentlyWork: target.checked })
                  }
                />
              </Col>
            </Form.Group>

            {!formData.currentlyWork && (
              <Form.Group as={Row} className="mb-3" controlId={name}>
                <Form.Label column sm={3} className="text-lg-end">
                  To
                </Form.Label>
                <Col sm={9} md={7}>
                  <DatePicker
                    selected={formData.to}
                    onChange={date => setFormData({ ...formData, to: date })}
                    className="form-control form-control-sm"
                    placeholderText="Select Date"
                  />
                </Col>
              </Form.Group>
            )}

            <Form.Group as={Row} className="mb-3">
              <Col sm={{ span: 10, offset: 3 }}>
                <Button type="submit">Save</Button>
              </Col>
            </Form.Group>
          </Form>

          <div className="border-dashed border-bottom my-3" />
        </div>
      </Collapse>
    </div>
  );
};

ExperienceForm.propTypes = {
  collapsed: PropTypes.bool.isRequired,
  setCollapsed: PropTypes.func.isRequired,
  experiences: PropTypes.any,
  setExperience: PropTypes.func.isRequired
};

export default ExperienceForm;
